import { useInitializeDocumentInfo, useInitializeDocumentSummary, useInitializeDocumentTypes, useInitializeDocumentUsers } from './hooks'

export const DocumentSummaryInitialization = () => {
  useInitializeDocumentInfo()
  useInitializeDocumentTypes()
  useInitializeDocumentUsers()
  useInitializeDocumentSummary()

  return null
}
